// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2pwVC","left":"InfoRow_left__2biyu"};